/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RegisterEntrySummary {
    /**
     * The ID of the entity this entry relates to. Needs to be read with registerEntityType to resolve the entity
     */
    entityId: number;
    /**
     * The ID of the authority this register is attached to
     */
    authorityId: number;
    /**
     * The name of the authority this register is attached to
     */
    authorityName: string;
    /**
     * The ID of the authority register that this entry is attached to
     */
    registerId: number;
    /**
     * The name of the register, derived from the authority and register type
     */
    registerName: string;
    /**
     * The type of entity that this register entity refers to. Used with entityId to resolve the entity.
     */
    registerEntityType: RegisterEntrySummary.RegisterEntityType;
    /**
     * The overall computed status of the entry
     */
    registerStatus: RegisterEntrySummary.RegisterStatus;
}
export namespace RegisterEntrySummary {
    export type RegisterEntityType = 'RPA' | 'PILOT';
    export const RegisterEntityType = {
        RPA: 'RPA' as RegisterEntityType,
        PILOT: 'PILOT' as RegisterEntityType
    };
    export type RegisterStatus =
        | 'PENDING'
        | 'ACTIVE'
        | 'SUSPENDED'
        | 'EXPIRED'
        | 'NOT_ON_REGISTER'
        | 'NOT_AVAILABLE'
        | 'AUTO';
    export const RegisterStatus = {
        PENDING: 'PENDING' as RegisterStatus,
        ACTIVE: 'ACTIVE' as RegisterStatus,
        SUSPENDED: 'SUSPENDED' as RegisterStatus,
        EXPIRED: 'EXPIRED' as RegisterStatus,
        NOT_ON_REGISTER: 'NOT_ON_REGISTER' as RegisterStatus,
        NOT_AVAILABLE: 'NOT_AVAILABLE' as RegisterStatus,
        AUTO: 'AUTO' as RegisterStatus
    };
}
